"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var Grid_1 = require("@lsg/components/lib/components/atoms/Grid/Grid");

var GridRow_1 = require("@lsg/components/lib/components/atoms/Grid/GridRow");

var GridColumn_1 = require("@lsg/components/lib/components/atoms/Grid/GridColumn");

var react_components_1 = require("@lws/react-components");

var functions_1 = require("../../utils/functions");

exports.BenefitsList = function (_a) {
  var data = _a.data;
  return react_1["default"].createElement(components_1.Grid, {
    verticalSpacing: Grid_1.Spacing.CONTAINER
  }, functions_1.makeColumnsLayoutArray(data).map(function (row, idx) {
    return react_1["default"].createElement(GridRow_1.GridRow, {
      gap: Grid_1.Spacing.CONTAINER,
      key: "benefits-row-" + idx
    }, row.map(function (col, i) {
      return react_1["default"].createElement(react_1["default"].Fragment, {
        key: "benefits-col-" + idx + "-" + i
      }, react_1["default"].createElement(GridColumn_1.GridColumn, {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
        xl: 6
      }, react_1["default"].createElement(react_components_1.FootnotesRichtextRenderer, {
        content: col.richText('headline'),
        wrapper: components_1.H3,
        wrapperOptions: {
          asSpan: true
        }
      }), react_1["default"].createElement(react_components_1.FootnotesRichtextRenderer, {
        content: col.richText('description'),
        wrapper: components_1.Paragraph
      }), react_1["default"].createElement("div", null)));
    }));
  }));
};